
import { apiConstants } from '../_constants';
import { utils } from '../_helpers';
import { alertActions } from '../_actions';
import { store } from '../_helpers/store';

export const currencyServices = {
    getDepositEnabledCurrencies , GetMemberWalletAvailableCurrency , GetTradeAbleCurrencies , GetCryptoTicker
}

function getDepositEnabledCurrencies (){
    
    return (
        utils.Get(`${apiConstants.ENDPOINT}currency/GetDepositEnabledCurrencies`)
        .then(response=>response)
    )
}

function GetMemberWalletAvailableCurrency (currencyType){

    let id = store.getState().authentication.user.id;
    let url = `${apiConstants.ENDPOINT}currency/GetMemberWalletAvailableCurrency/${id}`;

    if(currencyType !== undefined){
        url += `&currencyType=${currencyType}`;
    }
    
    return (
        utils.Get(url)
        .then(response=>response) 
    )
}

function GetTradeAbleCurrencies (currencyType){
    let url = `${apiConstants.ENDPOINT}currency/GetTradeAbleCurrencies`;

    if(currencyType !== undefined){
        url += `&currencyType=${currencyType}`;
    }

    return (
        utils.Get(url)
        .then(response=>response)
    )
}

function GetCryptoTicker (){
    return (
        utils.Get("https://api.coinmarketcap.com/v1/ticker/?limit=2")
        .then(response => response)
    )
}


// WEBPACK FOOTER //
// ./src/_services/currency.service.js